<template>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-22fe0e8 elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-motion-effects-element elementor-motion-effects-element-type-background" data-id="22fe0e8" data-element_type="section" data-e-type="section" data-settings="{'background_background':'classic','background_motion_fx_motion_fx_scrolling':'yes','background_motion_fx_scale_effect':'yes','background_motion_fx_scale_direction':'in-out','background_motion_fx_scale_speed':{'unit':'px','size':3,'sizes':[]},'background_motion_fx_scale_range':{'unit':'%','size':','sizes':{'start':0,'end':100}},'background_motion_fx_devices':['desktop']}" :style="{
    '--e-transform-transition-duration': '100ms',
    
    'background-position': 'center',
    backgroundImage: `url(${baseUploadURL}${homeContentStore.contents?.thinker?.banner?.uploadFile})`
  }">
    <div class="elementor-motion-effects-container">
      <div class="elementor-motion-effects-layer" style="width: 100%; height: 100%; --scale: 1.09429; transform: scale(var(--scale));"></div>
    </div>
    <div class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7ba97e9" data-id="7ba97e9" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-815e8db elementor-widget elementor-widget-heading animated fadeIn" data-id="815e8db" data-element_type="widget" data-e-type="widget" data-settings="{'_animation':'fadeIn','_animation_tablet':'none','_animation_delay':200}" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <p class="elementor-heading-title elementor-size-default" v-html="homeContentStore.contents?.thinker?.contents"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { onMounted } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'

  const baseUploadURL = process.env.VUE_APP_API_URL;

  export default {
    name: 'ThinkerSectionComponent',
    setup() {
      const homeContentStore = useHomeContentStore()

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
      })

      return {
        homeContentStore,
      }
    },
    data() {
      return{
        baseUploadURL: baseUploadURL,
      }
    },
  }
</script>

<style scoped>
.elementor-1905 .elementor-element.elementor-element-22fe0e8:not(.elementor-motion-effects-element-type-background), .elementor-1905 .elementor-element.elementor-element-22fe0e8 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-image: none;
}

.elementor-1905 .elementor-element.elementor-element-815e8db .elementor-heading-title {
  font-size: 90px;
  line-height: 110px;
}
</style>